import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import { Info } from '../components/Info';
import ComponenteCajasDeSeguridad from '../components/ComponenteCajasDeSeguridad';
import { CAJASSEGURIDAD_BANNER } from '../Constantes';




export const CajasDeSeguridad: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={CAJASSEGURIDAD_BANNER} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Mi Caja de Seguridad'} ></Title>
                                <Info info={'Completá los datos y en breve nos pondremos en contacto con vos, para que puedas consultar tus dudas y coordinar un turno. Una vez asignado vamos a esperarte en la sucursal el día acordado, así podés concluir tu contratación.'}></Info>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <ComponenteCajasDeSeguridad />
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>

                            El clic en SÍ ACEPTO implica conformidad para que los datos de esta presolicitud sean enviados al Banco de la Provincia de Buenos Aires y sin que ello importe su aceptación. Asimismo, tomo conocimiento de los <a style={{ color: "rgb(60, 60, 59)" }} href='https://www.bancoprovincia.com.ar/CDN/Get/TYC_BIP'>términos y condiciones para la utilización de Banca Internet Provincia</a> y de la información necesaria para su correcta utilización, los riesgos derivados de su empleo y quien asume los mismos. El clic en IMPRIMIR me permite obtener una copia que también se encuentra a la disposición en www.bancoprovincia.com.ar
                        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>

    )

}



